import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberPath } from '../utils/authRedirect';

/** Láthatatlan komponens: minden oldalváltáskor eltárolja az aktuális útvonalat (a belépés utáni visszalépéshez). */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    rememberPath(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;